var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-progress',{attrs:{"value":_vm.actualValue,"max":_vm.maxValue,"size":"is-large","type":"is-primary","show-value":""}},[_vm._v(" "+_vm._s(_vm.actualValue)+" / "+_vm._s(_vm.maxValue)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }